
$(function(){
  stndvarqty();
  function syncColorGallery(handle){
    var $thumbs = $('.gallery__thumbnail');
    if(!$thumbs.length || !handle){
      return;
    }

    var $untaggedThumbs = $thumbs.filter(function(){
      return this.className.indexOf('gt_') === -1;
    });

    var $matchedThumbs = $('.gallery__thumbnail.gt_'+handle);
    if($matchedThumbs.length <= 1){
      $matchedThumbs = $thumbs.filter(function(){
        return this.className.indexOf('gt_'+handle) !== -1;
      });
    }

    if($matchedThumbs.length > 1){
      $thumbs.hide();
      $untaggedThumbs.show();
      $matchedThumbs.show();
      $matchedThumbs.eq(0).click();
      return;
    }

    $thumbs.show();
    if($matchedThumbs.length){
      $matchedThumbs.eq(0).click();
    }
  }

   $('body').on( 'click','.swatch--color', function(e){
     var handle=$(this).attr('data-handle');
     syncColorGallery(handle);
     stndvarqty();
     
   });
  
  $('body').on( 'click','.stimulus_level', function(e){
stndvarqty();
    });

  if($('.swatch--color.swatch--active').length){
    var handle=$('.swatch--color.swatch--active').attr('data-handle');
     syncColorGallery(handle);
  }
 $('body').on( 'click','.collapsible-header', function(e){
    if($(this).closest("li").hasClass( "active" )){
      
      $(this).next().slideUp('fast');
      $(this).closest("li").removeClass('active');
    }else{
      
      $(this).next().slideDown('fast');
      $(this).closest("li").addClass('active');
    }
   });

   $('body').on('click', '.localization-btn__toggle', function(e){
     e.preventDefault();
     e.stopPropagation();

     var $button = $(this);
     var $holder = $button.closest('.localization-btn').find('.localization-btn__holder');

     $('.localization-btn__holder').not($holder).removeClass('currencyholder');
     $('.localization-btn__toggle').not($button).attr('aria-expanded', 'false');
     $holder.toggleClass('currencyholder');
     $button.attr('aria-expanded', $holder.hasClass('currencyholder') ? 'true' : 'false');
   });

   $('body').on('click', function(e){
     if($(e.target).closest('.localization-btn').length) return;

     $('.localization-btn__holder').removeClass('currencyholder');
     $('.localization-btn__toggle').attr('aria-expanded', 'false');
   });

   $('body').on('keydown', function(e){
     if(e.key !== 'Escape') return;

     $('.localization-btn__holder').removeClass('currencyholder');
     $('.localization-btn__toggle').attr('aria-expanded', 'false');
   });
  
});

function stndvarqty(){
  if($('.stimulus_level').length){
    var option1=$('.stimulus_level.swatch--active').attr('data-swatch-option');
  }else{
 var option1=$('.swatch--color.swatch--active').attr('data-swatch-option');
  }
  if($("#v_qty").length){
    $('.ssize').each(function(){
      var size=$(this).attr('data-swatch-option');
      var v_qty=option1+' / '+size;
     
      var sold=$('#v_qty').find('option[value="' +v_qty+ '"]').text();
      if(sold == 'true'){
      
      $(this).attr('data-swatch-soldout',sold);
      }else{
        
        $(this).removeAttr( "data-swatch-soldout" );
      }
    });
    
  }
}

function moveDiv(){
  if(document.getElementsByClassName("shoes-temp").length){
  if(window.innerWidth < 768){
  var colorswatch = document.getElementsByClassName("shoes-temp")[0];
  var product_page = document.getElementById("product--page");
  product_page.prepend(colorswatch);
  }else{
     var colorswatch = document.getElementsByClassName("shoes-temp")[0];
      var product_page = document.getElementById("swatches_boxs");
      product_page.prepend(colorswatch);
  }
  }
}
window.addEventListener("load", function(event) {
    moveDiv();
});
window.addEventListener("resize", function(event) {
    moveDiv();
});





equalheight = function(container){

  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {
    $el = $(this);
    $($el).height('auto')
    var topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}
$(document).ready(function(){
    equalheight('.section--account-cards .account-card');
  $(window).on('resize', function(){
  equalheight('.section--account-cards .account-card');
});
});



$(document).on('click', '#sizecodes_tbl th', function() {
   //third parameter int if number only
  sortTable($(this).index(),'sizecodes_tbl','');
});

function sortTable(n,id,type) {
  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById(id);
  switching = true;
  //Set the sorting direction to ascending:
  dir = "asc"; 
  /*Make a loop that will continue until
  no switching has been done:*/
  while (switching) {
    //start by saying: no switching is done:
    switching = false;
    rows = table.getElementsByTagName("TR");
    /*Loop through all table rows (except the
    first, which contains table headers):*/
    for (i = 1; i < (rows.length - 1); i++) {
      //start by saying there should be no switching:
      shouldSwitch = false;
      /*Get the two elements you want to compare,
      one from current row and one from the next:*/
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
      /*check if the two rows should switch place,
      based on the direction, asc or desc:*/
	  if(type == "int") {
		  if (dir == "asc") {
			if (parseFloat(x.innerHTML.toLowerCase()) > parseFloat(y.innerHTML.toLowerCase())) {
			  //if so, mark as a switch and break the loop:
			  shouldSwitch= true;
			  break;
			}
		  } else if (dir == "desc") {
			if (parseFloat(x.innerHTML.toLowerCase()) < parseFloat(y.innerHTML.toLowerCase())) {
			  //if so, mark as a switch and break the loop:
			  shouldSwitch= true;
			  break;
			}
		  }
	  } else {
		  if (dir == "asc") {
			if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
			  //if so, mark as a switch and break the loop:
			  shouldSwitch= true;
			  break;
			}
		  } else if (dir == "desc") {
			if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
			  //if so, mark as a switch and break the loop:
			  shouldSwitch= true;
			  break;
			}
		  }
	  }
    }
    if (shouldSwitch) {
      /*If a switch has been marked, make the switch
      and mark that a switch has been done:*/
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      //Each time a switch is done, increase this count by 1:
      switchcount ++;      
    } else {
      /*If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again.*/
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}

$(document).ready(function(){
      $('body').on('keyup','#namesearch',function(){
                var searchtext = $('#namesearch').val();
                if(searchtext.length >= 3){
                    $('#sizecodes_tbl .fmrow').each(function(){
                        var $this = $(this);
                        var $text = $this.find('.name').text();
                        var indexcount = $text.indexOf(searchtext);
                        if(indexcount > -1){
                            $this.show();
                        }else{
                            $this.hide();
                        }
                    });
                }
                if(searchtext.length == 0){
                    $('#sizecodes_tbl .fmrow').show();
                }
            });

 });
   
  
